import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Autocomplete, TextField } from "@mui/material";

const DashboardConfig = () => {
  const [product, setProduct] = useState(null);
  const [productList, setProductList] = useState([]);
  const navigate = useNavigate();

  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/onboarded-products`);
        setProductList(response.data);
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    };

    fetchProducts();
  }, [BASE_URL]);

  const handleConfigure = () => {
    if (product) {
      const encodedProductName = encodeURIComponent(product.productName || "");
      const newTabUrl = `/product-report/${product.productId}?product=${encodedProductName}`;
      window.open(newTabUrl, "_blank");
    }
  };

  return (
    <div className=" flex mt-[4rem] items-center justify-center p-4">
      <div className="w-96 sm:w-[450px] md:w-[500px] bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden  pt-4">
        <div className="bg-[#0874BE] px-6 py-3 ">
          <h2 className="text-center text-2xl  font-semibold text-white">
            Dashboard Configuration
          </h2>
          <p className="text-center text-[14px] text-white mt-1">
            Configure your dashboard settings to get started
          </p>
        </div>

        <div className="px-6 py-6">
          <div className="mb-4">
            <Autocomplete
              id="product"
              options={productList}
              getOptionLabel={(option) => option.productName || ""}
              value={product}
              onChange={(event, newValue) => {
                setProduct(newValue);
                if (newValue) {
                  localStorage.setItem(
                    "selectedProductName",
                    newValue.productName
                  );
                } else {
                  localStorage.removeItem("selectedProductName");
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Product Name"
                  placeholder="Search a product..."
                />
              )}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#0874BE",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#0874BE",
                  },
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#0874BE",
                },
              }}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              isOptionEqualToValue={(option, value) =>
                option.productId === value?.productId
              }
            />
          </div>

          <button
            className={`w-full py-2.5 rounded-md text-sm font-medium shadow-sm focus:outline-none transition ${product
                ? "bg-[#80C6AD]  text-white"
                : "bg-[#99d1bc] text-white cursor-not-allowed opacity-60"
              }`}
            onClick={handleConfigure}
            disabled={!product}
          >
            Configure Dashboards
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardConfig;
